<template>
  <div>
    <header>
      <at-header-top></at-header-top>
      <at-header-middle></at-header-middle>
      <Navbar />
    </header>
  </div>
</template>

<script>
import AtHeaderTop from "@/esf_antarctica_lederhosenland/core/components/header/HeaderTop.vue";
import AtHeaderMiddle from "@/esf_antarctica_lederhosenland/core/components/header/HeaderMiddle.vue";
import Navbar from "@/esf_antarctica_lederhosenland/core/components/header/NavBar.vue";

export default {
  components: {
    AtHeaderTop,
    AtHeaderMiddle,
    Navbar,
  },

  data() {
    return {
      isHamVisible: false,
    };
  },

  methods: {
    toggleHamView() {
      // this.$store.commit("home/updateOverlay");
      this.isHamVisible = !this.isHamVisible;
    },
  },
};
</script>

<style>
</style>